import React, { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Executions, FirmList, FTPInstructions, SelectionCriteria, FileUploadLogs, FileUpload } from './';

import { cs2Actions, alertActions } from '../_actions';

import dateFormat from 'dateformat';

import 'react-datepicker/dist/react-datepicker.css';

function CS2PlusPage() {
    const user = useSelector(state => state.authentication.user);
    const dispatch = useDispatch();
    const [menuSelection, setMenuSelection] = useState("EXECUTIONS");

    useEffect(() => {
		//dispatch(userActions.getEntitlements(user.shortName));
    }, []);

    function handleTradeDateChanges(tdate) {
    	
    setTradeDate(tdate);
   	 
   	 console.log("------------------- handleTradeDateChanges -------------------" + tdate);  
   	 console.log("------------------- handleTradeDateChanges -------------------" + dateFormat(tdate, "yyyymmdd"));
   	  
        dispatch(cs2Actions.cs2Executions(dateFormat(tdate, "yyyymmdd")));
        
    }
    
    function handleCS2MenuSelection(select) {

    	//dispatch(alertActions.clear());
    	switch (select) {
    		case "EXECUTIONS": 
    			setMenuSelection("EXECUTIONS");    			
    			break;
    			
    		case "FIRM_LIST": 
    			setMenuSelection("FIRM_LIST");
    			break;
    			
    		case "FTP_INSTRUCTIONS": 
    			setMenuSelection("FTP_INSTRUCTIONS");
    			break;

    		case "FILE_UPLOAD_LOGS": 
    			setMenuSelection("FILE_UPLOAD_LOGS");
    			break;
    			
    		case "FILE_UPLOAD": 
    			setMenuSelection("FILE_UPLOAD");
    			break;
    			
    		default: 
    			break;	
    	}
    }

    return (
    	<div className="container-fluid">	
     		
	    		<div className="alert alert-dark text-center"   >
	    			<span className="space"><strong>Firm Name:</strong> { user.efpPartners.bpCompanyName }</span> <span className="space"><strong>Name:</strong> { user.fullName } - ( {user.shortName} ) </span> <span className="space"><strong>Phone:</strong> { user.officePhone } </span>
	    		</div>
	    	
    	
	    		<div  className="row" >	
	        	<div className="col-md-2" >
	        		{ /* <CS2Menu/> */ }
	        		<h3>Crossing Session 2</h3>
	        		<div className="list-group" >
	    				<a onClick={() => handleCS2MenuSelection("EXECUTIONS")} className="list-group-item list-group-item-action">CS2 Executions</a>
	    				<a onClick={() => handleCS2MenuSelection("FIRM_LIST")} className="list-group-item list-group-item-action">CS2 Firm List</a>
	    				<a onClick={() => handleCS2MenuSelection("FTP_INSTRUCTIONS")} className="list-group-item list-group-item-action">FTP Instructions</a>
	    				<a onClick={() => handleCS2MenuSelection("FILE_UPLOAD_LOGS")} className="list-group-item list-group-item-action">File Upload Logs</a>
	    				<a onClick={() => handleCS2MenuSelection("FILE_UPLOAD")} className="list-group-item list-group-item-action">File Upload</a>
	    		  	</div>
	        	</div>
	        	<div className="col-md-10"  >	
	        		{ (menuSelection === 'EXECUTIONS' && <div><SelectionCriteria/> <Executions/></div>)
	        		|| (menuSelection === 'FIRM_LIST' && <FirmList/> )
	        		|| (menuSelection === 'FTP_INSTRUCTIONS' && <FTPInstructions/>)
	        		|| (menuSelection === 'FILE_UPLOAD_LOGS' && <FileUploadLogs/>) 
	        		|| (menuSelection === 'FILE_UPLOAD' && <FileUpload/>)}
	        	</div>
	        	</div>
	      
        </div>
    );
}

export { CS2PlusPage };